module.exports = __webpack_public_path__ + "img/9_of_Hearts.svg.3b725bac.png";